module.exports = __webpack_public_path__ + "img/global-2010-hokkaido.25e72dae.jpg";